import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as domains from '../../domains'

export const RESOURCE = {
  payload: {
    description:
      'Domains that Attain delivers in, to be connected to Organizations, Offerings, Projects, and Proposals',
    dimension: domains.RESOURCE.payload,
    level: 0,
    name: 'Domain',
    partialId: PartialId.Standard.create('domain'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
